import { HomeTestID } from "@/constants/TestID";
import useAppUserTransitionTrackStatus from "@/hooks/useAppUserTransitionTrackStatus";
import { UnencryptedStorageKey } from "@/hooks/useUnencryptedStorage";
import RecommendedContentCard from "@/ui/components/home/RecommendedContentCard";

enum RecommendedFAQContent {
  BlurbText = "Have questions about treatment at Equip? We've got answers—check out our FAQ.",
  DefaultUrl = "https://equip.health/admissions-packet",
  Title = "Have questions about treatment at Equip?",
  TransitionTrackUrl = "https://equip.health/HLOC-admissions-packet",
}

const RecommendedFAQ = () => {
  const { isAppUserPatientInTransitionTrack } =
    useAppUserTransitionTrackStatus();

  const contentUrl = isAppUserPatientInTransitionTrack
    ? RecommendedFAQContent.TransitionTrackUrl
    : RecommendedFAQContent.DefaultUrl;

  return (
    <RecommendedContentCard
      analyticsSource={RecommendedFAQ.name}
      analyticsTitle={RecommendedFAQContent.Title}
      blurbText={RecommendedFAQContent.BlurbText}
      contentUrl={contentUrl}
      imageSource={require("@/assets/images/components/home_resources/recommended-faq.png")}
      storageKey={UnencryptedStorageKey.HomeTabRecommendedFAQDismissed}
      testID={HomeTestID.RecommendedFAQ}
    />
  );
};

export { RecommendedFAQContent };
export default RecommendedFAQ;
